<template>
  <div>
    <ImportAccountsPanel/>
    <FilterOrganization :disabled="false" @option="onOptionChange" :option="option"/>
    <ManagementAccountHistory  caption="Accounts" icon="cil-user" :item="accounts"  :option="option"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ManagementAccountHistory from "@/projects/views/E-Performances/Management/Accounts/components/Historys";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization";
import ImportAccountsPanel from "@/projects/views/E-Performances/Management/Accounts/components/ImportAccountsPanel";

export default {
  name: "Accounts",
  components: {ImportAccountsPanel, FilterOrganization, ManagementAccountHistory},
  data: function () {
    return {
      accounts:[],
      option:{
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 543,
      },
    }
  },

  mounted() {
  },

  created() {
    this.onInit();
  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad()
    },

    onLoad() {
      var data = {};
      data.organization = this.option.organization;
      (this.option.agency != 0)?data.agency = this.option.agency:null;

      this.$store.dispatch("member/config", data)
    },

    onOptionChange(e){
      this.isShow = false;
      this.option = e;
      // this.onLoad();
    },

    buildDisplayName(userinfo) {
      var lang = this.$store.getters['setting/lang'];

      var prefix = this.findLanguageValue(userinfo.prefix, lang);
      var firstName = this.findLanguageValue(userinfo.firstName, lang);
      var lastName = this.findLanguageValue(userinfo.lastName, lang);

      console.log("1",prefix, firstName, lastName)

      return [prefix, firstName, lastName].filter(Boolean).join(" ") || "-";
    },

    findLanguageValue(items, lang) {
      if (!Array.isArray(items)) {
        return "";
      }

      var found = items.find(function (entry) {
        return entry.key == lang;
      });

      return (found || {}).value || "";
    },
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      objsMember : "member/members",
    })
  },

  watch: {
    objsMember: function (value) {
      this.accounts = [];
      var items = [];
      value.filter(item => {
        var account = (item || {}).accounts || {};
        var userinfo = account.userinfo || {};
        var objs = {
          code: account.code || ((account.authen || {}).username) || "-",
          info: this.buildDisplayName(userinfo),
          value: item,
          historys: []
        };

        items.push(objs);
      })
      this.accounts = items;

    },

    "option.organization"(value){
      this.onLoad()
    },

    "option.agency"(value){
      this.onLoad()
    },

  }
}
</script>

<style scoped>

</style>
